/** 帳票の対象を決めるのに必要な最小の delivery 情報 */
type PrintableDelivery = { id: number; shiftId: number | null | undefined };

/**
 * 帳票出力の対象 shift。
 *
 * 車両を選んでいればその勤務だけ、選んでいなければその日の全勤務を出す。
 * 選択が delivery に解決できないとき（仮想回転など）も全件へ戻す。ここで空を返すと
 * アイコンを押しても何も出ない状態になる。
 */
export function resolvePrintTargetShiftIds(
  selectedShiftTruckIds: number[],
  deliveries: PrintableDelivery[],
): number[] {
  const shiftIdOf = (d: PrintableDelivery) => (typeof d.shiftId === 'number' ? d.shiftId : null);

  const selected = new Set<number>();
  selectedShiftTruckIds.forEach((stid) => {
    const shiftId = shiftIdOf(deliveries.find((d) => d.id === stid) ?? { id: -1, shiftId: null });
    if (shiftId != null) selected.add(shiftId);
  });
  if (selected.size > 0) return Array.from(selected);

  const all = new Set<number>();
  deliveries.forEach((d) => {
    const shiftId = shiftIdOf(d);
    if (shiftId != null) all.add(shiftId);
  });
  return Array.from(all);
}
